import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class GenericService {

  // private baseUrl = environment.EXTERNAL.serviceAfiliado;
  private baseUrl = `${environment.HOST}${URL_MAP.EXTERNAL.serviceAfiliado}`;

  constructor(private http: HttpClient) {}

post(endpoint: string, body: any): Observable<any> {
  const url = `${this.baseUrl}/${endpoint}`;  // Concatenamos el endpoint a la URL base

  return this.http.post<any>(url, body).pipe(
    catchError((error) => {
      console.error('Error en la solicitud POST:', error);
      return throwError(error);  // Retornamos el error para que pueda ser manejado en el componente
    })
  );
}

}
